export default __webpack_public_path__ + "static/media/ManufacturingIndustries_bg.9fd70070.jpg";